export const Wordmark = ({ variant = "burgundy", compact = false }) => {
  const primary = variant === "cream" ? "#FDFBF7" : "#6E2638";
  const gold = "#D4AF37";
  const forest = variant === "cream" ? "#E7C766" : "#1E4637";

  return (
    <div className="flex items-center gap-3" data-testid="wordmark">
      <svg width="46" height="46" viewBox="0 0 46 46" aria-hidden="true" className="shrink-0">
        <circle cx="23" cy="23" r="22" fill="none" stroke={gold} strokeWidth="1" />
        <circle cx="23" cy="23" r="18" fill={primary} />
        <text x="23" y="30" textAnchor="middle" fontFamily="Playfair Display, serif"
              fontSize="22" fontStyle="italic" fill="#FDFBF7" fontWeight="700">M</text>
        <path d="M 10 41 Q 23 46 36 41" fill="none" stroke={gold} strokeWidth="0.8" />
      </svg>
      <div className="leading-tight">
        <div
          className={`serif ${compact ? "text-sm" : "text-[15px] md:text-base"} whitespace-nowrap`}
          style={{ color: primary }}
        >
          <span className="italic" style={{ color: gold }}>Martin's</span>{" "}
          Marvellous Melbourne Walking Tours
        </div>
        <div
          className="text-[10px] tracking-[0.28em] uppercase"
          style={{ color: forest }}
        >
          Walking Tours · 1835 — 2026
        </div>
      </div>
    </div>
  );
};

export default Wordmark;
